import { render, staticRenderFns } from "./SpeakingSkill.vue?vue&type=template&id=e0dbd5b0&scoped=true"
import script from "./SpeakingSkill.vue?vue&type=script&lang=js"
export * from "./SpeakingSkill.vue?vue&type=script&lang=js"
import style0 from "./SpeakingSkill.vue?vue&type=style&index=0&id=e0dbd5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dbd5b0",
  null
  
)

export default component.exports